import { isPlatformBrowser } from '@angular/common';
import {
  Injectable,
  PLATFORM_ID,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { ModuleType } from '@contracts';

const MODULE_KEY = 'module';

@Injectable({ providedIn: 'root' })
export class ModuleStore {
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  private readonly _module = signal<ModuleType | null>(null);
  readonly module = this._module.asReadonly();

  readonly isEms = computed(() => this._module() === 'EMS');

  constructor() {
    if (this.isBrowser) {
      const saved = localStorage.getItem(MODULE_KEY);

      if (typeof saved === 'string') {
        this._module.set(saved);
      }
    }

    effect(() => {
      if (!this.isBrowser) return;
      const m = this._module();
      if (m) {
        localStorage.setItem(MODULE_KEY, m);
      }
    });
  }

  setModule(module: ModuleType) {
    this._module.set(module);
  }
}
